export const CN_LOCAL_STORAGE_ADDRESS_KEY = 'chownowAddress';
export const CN_LOCAL_STORAGE_FULFILLMENT_KEY = 'fulfillmentMethod';

export const apiFulfillmentMethods = {
  delivery: 'deliversToMe',
};

// Match the address we store to the format used in cn-web-ordering
export function formatAddress(address, id) {
  return {
    formatted_address: address?.formatted_address,
    saved_address_id: id || '',
  };
}

export function writeAddressToLocalStorage(address, id) {
  if (!localStorage) return false;
  const formattedAddress = formatAddress(address, id);
  if (formattedAddress && formattedAddress !== 'undefined') {
    localStorage.setItem(CN_LOCAL_STORAGE_ADDRESS_KEY, JSON.stringify(formattedAddress));
    return true;
  }
  return false;
}

export function readAddressFromLocalStorage() {
  if (!localStorage) return '';
  const storedAddress = localStorage.getItem(CN_LOCAL_STORAGE_ADDRESS_KEY);
  if (!storedAddress || storedAddress === 'undefined') return '';
  return JSON.parse(localStorage.getItem(CN_LOCAL_STORAGE_ADDRESS_KEY));
}

export function clearSavedAddressId() {
  // On logout, we clear the saved address id, but still persist the address in local storage
  const { formatted_address: formattedAddress, saved_address_id: savedAddressId } =
    readAddressFromLocalStorage();

  if (savedAddressId) writeAddressToLocalStorage({ formatted_address: formattedAddress });
}

export function writeFulfillmentTypeToLocalStorage(method = apiFulfillmentMethods.delivery) {
  if (!localStorage) return false;

  // We want to maintain a consistent formatting here between the API, URL and LocalStorage
  // Create an object with a 0/1 Boolean associated with a given fulfillment method
  const lookup = {};

  if (method === 'delivery') {
    lookup[apiFulfillmentMethods.delivery] = 1;
  } else {
    lookup[apiFulfillmentMethods.delivery] = 0;
  }

  localStorage.setItem(CN_LOCAL_STORAGE_FULFILLMENT_KEY, JSON.stringify(lookup));
  return true;
}

export function readFulfillmentFromLocalStorage() {
  if (!localStorage) return '';
  const storedFulfillment = localStorage.getItem(CN_LOCAL_STORAGE_FULFILLMENT_KEY);
  if (!storedFulfillment || storedFulfillment === 'undefined') return '';
  return JSON.parse(localStorage.getItem(CN_LOCAL_STORAGE_FULFILLMENT_KEY));
}

export function addMatchingSavedAddressIdToLocalStorage(savedAddresses) {
  const { formatted_address: formattedAddress } = readAddressFromLocalStorage();
  const matchingAddress = savedAddresses.find((s) => s.formatted_address === formattedAddress);
  if (matchingAddress) {
    writeAddressToLocalStorage(matchingAddress, matchingAddress.id);
  }
}
